import React from 'react';

import PropTypes from 'prop-types';
import UpwardLoadingButton from '../../Buttons/LoadingButton';

const ButtonsSubmitExport = ({ isLoading, handleSubmit, handleExport, showExport, ...props }) => {
   return (
      <div className='clearfix'>
         <div className='pr-2 d-inline-block'>
            <UpwardLoadingButton
               onClick={handleSubmit}
               type='submit'
               className='btn-dark-orange btn-rounded'
               isLoading={isLoading}
            >
               {props.label ? props.label : 'Submit'}
            </UpwardLoadingButton>
         </div>
         {showExport
            && (
               <div className='pl-2 d-inline-block'>
                  <UpwardLoadingButton
                     onClick={handleExport}
                     className='btn-light btn-rounded'
                     isLoading={isLoading}
                  >
                     Export
                  </UpwardLoadingButton>
               </div>
            )}
      </div>
   );
};

ButtonsSubmitExport.propTypes = {
   isLoading: PropTypes.bool,
   showExport: PropTypes.bool,
   handleSubmit: PropTypes.func,
   handleExport: PropTypes.func,
};

ButtonsSubmitExport.defaultProps = {
   isLoading: false,
   showExport: false,
   handleSubmit: null,
   handleExport: null,
};

export default ButtonsSubmitExport;
